import DetailsSection from './components/details-section';
import Footer from './components/footer';
import Header from './components/header';
import HeroSection from './components/hero-section';
import IdentityStrip from './components/identity-strip';
import LocationSection from './components/location-section';
import ProfileSection from './components/profile-section';

function App() {
  return (
    <div id="top" className="min-h-screen bg-fd-ivory text-fd-ink">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50 focus:border-2 focus:border-fd-ink focus:bg-fd-paper focus:px-4 focus:py-2 focus:font-bold focus:text-fd-ink">
        Skip to content
      </a>
      <Header />
      <main id="main">
        <HeroSection />
        <IdentityStrip />
        <ProfileSection />
        <LocationSection />
        <DetailsSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
